import React, { Suspense, useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import VerifyPayment from "./components/pages/VerifyPayment";

// Preloader
import Preloader from "./components/layouts/Preloader";

// Pages
// const Home from "./components/pages/Home";
// const Hometwo from "./components/pages/Hometwo";
// const Homethree from "./components/pages/Homethree";
// const Homefour from "./components/pages/Homefour";
// const About from "./components/pages/About";
// const Login from "./components/pages/Login";
// const Register from "./components/pages/Register";
import Checkout from "./components/pages/Checkout";
import Cart from "./components/pages/Cart";
// const Legal from "./components/pages/Legal";
import Error from "./components/pages/Error";
import Menuone from "./components/pages/Menuone";
// const Menutwo from "./components/pages/Menutwo";
import Menuitemone from "./components/pages/Menuitemone";
// const Menuitemtwo from "./components/pages/Menuitemtwo";
// const Contact from "./components/pages/Contact";
import Mentions from "./components/pages/Mentions";
import Protection from "./components/pages/Protection";
import CGV from "./components/pages/Cgv";
import Success from "./components/pages/Success";

const ScrollToTop = ({ children, location: { pathname } }) => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
	return children || null;
};

function App() {
	let location = useLocation();
	return (
		// <Router>
		<Suspense fallback={<div></div>}>
			<ScrollToTop location={location}>
				{/* <Preloader /> */}
				<Routes>
					<Route exact path="/" element={<Menuone />} />
					<Route exact path="/menu/:menuId" element={<Menuitemone />} />
					<Route path="/check-paiement" element={<VerifyPayment />} />
					<Route path="/checkout" element={<Checkout />} />
					<Route path="/cart" element={<Cart />} />
					<Route path="/success" element={<Success />} />
					<Route path="/error" element={<Error />} />
					<Route path="/mentions-legales" element={<Mentions />} />
					<Route path="/conditions-generales-ventes" element={<CGV />} />
					<Route path="/protection-des-donnees" element={<Protection />} />

					{/* <Route path="/home-v2" component={Hometwo} />
					<Route path="/home-v3" component={Homethree} />
					<Route path="/home-v4" component={Homefour} /> */}
					{/* <Route path="/about" component={About} /> */}
					{/* <Route path="/login" component={Login} />
					<Route path="/register" component={Register} /> */}

					{/* <Route path="/legal" component={Legal} /> */}

					{/* <Route path="/menu-v2" component={Menutwo} /> */}
					{/* <Route
						path="/menu/:id"
						exact
						element={(props) => (
							<Menuitemone {...props} key={window.location.pathname} />
						)}
					/> */}
					{/* <Route
						path="/menu-item-v2/:id"
						exact
						component={(props) => (
							<Menuitemtwo {...props} key={window.location.pathname} />
						)}
					/> */}
					{/* <Route path="/locations" component={Locations} /> */}
					{/* <Route path="/contact" component={Contact} /> */}
				</Routes>
			</ScrollToTop>
		</Suspense>
		// </Router>
	);
}

export default App;
